module.exports = __webpack_public_path__ + "static/media/sx.6c22419a.svg";